import { schema } from "normalizr";

const language = new schema.Entity(`languages`);
const arrayOfLanguages = [language];

export { language, arrayOfLanguages };
